import config from '@/router/config'

const getToken = () => localStorage.getItem( config.tokenName )

export default getToken
